import { Form } from "react-bootstrap";
import { Assets } from "../../../assets";
import { useParams } from "react-router";
import { StaffService } from "./core/_request";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import dayjs from "dayjs";
import { CustomCalendar } from "../../../common/components/Calendar/CustomCalendar";
import { EventContentArg } from "@fullcalendar/core";
import { MdOutlineEventBusy } from "react-icons/md";
import { useEffect, useState } from "react";
import { Loader } from "../../../common/components/Loader/Loader";
import { HttpStatusCode } from "axios";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { BsCalendar2Date } from "react-icons/bs";
import { Tag } from "antd";
import { FaArrowRightLong } from "react-icons/fa6";

export interface AbsenceTypeModel {
  "@id": string;
  "@type": string;
  name: string;
  id: string;
}

export interface AbsenceModel {
  "@id": string;
  "@type": string;
  absenceType: AbsenceTypeModel;
  reason: string;
  startAt: string;
  endAt: string;
}

export const EmployeeDetail = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<any>();
  const [selectedAbsence, setSelectedAbsence] = useState<any>(null);

  useEffect(() => {
    id && loadEmployeeById(+id);
  }, [id]);

  const loadEmployeeById = async (id: number) => {
    setIsLoading(true);
    try {
      const res = await StaffService.getOneStaff(id);
      if (res?.status === HttpStatusCode.Ok) {
        setUserInfo(res?.data);
      }
    } catch (error) {
      console.error("Failed to load employee details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatListData = (data: any) => {
    return data?.map((item: any) => ({
      ...item,
      start: item?.startAt
        ? dayjs(item?.startAt, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
        : null,
      end: item?.endAt
        ? dayjs(item?.endAt, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD")
        : null,
    }));
  };

  const onOpenDrawerHandler = () => {
    setIsOpenDrawer((prev: boolean) => {
      if (prev) {
        setSelectedAbsence(null);
      }
      return !prev;
    });
  };

  const onClickOnAbsenceHandler = (abs: any) => {
    setSelectedAbsence(abs);
    onOpenDrawerHandler();
  };

  const tagPlusStyle: React.CSSProperties = {
    borderStyle: "dashed",
  };

  return (
    <div>
      <TitleHeader isSHowBack title="" subTitle="Détails" />
      <Loader isLoading={isLoading} />

      <div className="px-3">
        <div className="row">
          <div className="col-3 p-3 detail-perso">
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f4f6fa",
                  borderRadius: "50%",
                  width: 100,
                  height: 100,
                }}
              >
                <img
                  className="avatar"
                  src={
                    userInfo?.image?.contentUrl
                      ? userInfo?.image.contentUrl
                      : Assets.images.avatarThumb
                  }
                  alt="avatar"
                  style={{
                    width: 100,
                    height: 100,
                    objectFit: "cover",
                    borderRadius: "50%",
                    background: "#fff",
                  }}
                />
              </div>
              <div className="d-flex flex-wrap " style={{ maxWidth: 320 }}>
                <div className="fw-bolder fs-5 my-1 text-nowrap">
                  {userInfo?.firstname} &nbsp;
                </div>
                <div className="fw-bolder fs-5 my-1  text-nowrap">
                  {userInfo?.lastname ?? ""}
                </div>
              </div>
              <div className="fs-10 text-secondary">
                <span>
                  {"N° matricule: "}{" "}
                  <span className="fw-semibold">
                    {" "}
                    {userInfo?.registrationNumber}
                  </span>
                </span>
              </div>
              <div className="fs-10 text-secondary">
                <span className="fw-semibold">
                  {userInfo?.departmentType?.name}
                </span>
              </div>
            </div>
            <Form>
              <div className="mt-4 fw-bold mb-3">Information personnelle</div>

              <Form.Group className="mb-2">
                <Form.Label style={{ color: "#677788" }}>Téléphone</Form.Label>
                <Form.Control
                  placeholder="+2613XXXXXXX"
                  name="phoneNumber"
                  value={userInfo?.phoneNumber}
                  disabled
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label style={{ color: "#677788" }}>Adresse</Form.Label>
                <Form.Control
                  placeholder="lot xyz"
                  name="address"
                  value={userInfo?.address}
                  disabled
                />
                <span className="text-danger fs-8"></span>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label style={{ color: "#677788" }}>Email</Form.Label>
                <Form.Control
                  placeholder="example@mail.net"
                  name="email"
                  value={userInfo?.email}
                  disabled
                />
                <span className="text-danger fs-8"></span>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label style={{ color: "#677788" }}>
                  Date d'embauche
                </Form.Label>
                <Form.Control
                  placeholder="15/01/2000"
                  name="hiringDate"
                  value={dayjs(userInfo?.hiringDate).format("YYYY-MM-DD")}
                  type="date"
                  disabled
                />
              </Form.Group>
            </Form>
          </div>

          <div className="col-8 mx-4 p-3 detail-perso">
            <CustomCalendar
              onClick={(e: any) => {
                console.log(e);
              }}
              events={formatListData(userInfo?.absences)}
              renderContent={(e: EventContentArg) => (
                <div
                  className={"calendar__event"}
                  style={{
                    padding: "10px",
                  }}
                  onClick={() => {
                    onClickOnAbsenceHandler(e?.event?.extendedProps);
                  }}
                >
                  <div className={"calendar__event_icon"}>
                    <MdOutlineEventBusy size={20} />
                  </div>
                  <span className={"calendar__event_title"}>
                    {e?.event?.extendedProps?.absenceType?.name}
                  </span>
                </div>
              )}
            />
          </div>

          {isOpenDrawer ? (
            <CustomDrawer
              isOpen={isOpenDrawer}
              onClose={onOpenDrawerHandler}
              width={400}
              title={`Détail  `}
            >
              <div className="d-flex gap-4 flex-column">
                <div className="">
                  <Tag
                    color="#108ee9"
                    icon={<BsCalendar2Date style={{ fontSize: "22px" }} />}
                  >
                    <span>&nbsp; {selectedAbsence?.absenceType?.name}</span>
                  </Tag>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <Tag style={tagPlusStyle}>
                    {selectedAbsence?.startAt}{" "}
                    <FaArrowRightLong color="#108ee9" />{" "}
                    {selectedAbsence?.endAt}
                  </Tag>
                </div>

                <div className="">
                  <span
                    style={{
                      fontSize: "13px",
                    }}
                  >
                    Raison :{" "}
                  </span>
                  <div className="input-shadow">
                    {" "}
                    {selectedAbsence?.reason}{" "}
                  </div>
                </div>
              </div>
            </CustomDrawer>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};
